import { useLazyQuery, useQuery } from "@apollo/client";
import { PRODUCTS } from "../products.queries";
import {
  ProductsQuery,
  ProductsQueryVariables,
} from "../../../__generated__/ProductsQuery";

export const useProducts = (variables: ProductsQueryVariables) => {
  return useQuery<ProductsQuery, ProductsQueryVariables>(PRODUCTS, {
    variables,
    fetchPolicy: "network-only",
  });
};

export const useLazyProducts = () => {
  return useLazyQuery<ProductsQuery, ProductsQueryVariables>(PRODUCTS);
};
